export default {
  CLIENT: 'CLIENT',
  EXTERNAL: 'EXTERNAL',
  ADMIN: 'ADMIN'
}